import { movies, type Movie } from "@/mocks/movies";

export function getMovieById(id: string): Movie | undefined {
  return movies.find((m) => m.id === id);
}

export function getRelatedMovies(movie: Movie, count: number): Movie[] {
  const sameGenre = movies.filter(
    (m) => m.id !== movie.id && m.genres.some((g) => movie.genres.includes(g))
  );
  const others = movies.filter(
    (m) => m.id !== movie.id && !sameGenre.some((s) => s.id === m.id)
  );
  return [...sameGenre, ...others].slice(0, count);
}

export function filterMovies(
  list: Movie[],
  opts: { region?: string; year?: string; genre?: string }
): Movie[] {
  return list.filter((m) => {
    if (opts.region && opts.region !== "全部" && m.region !== opts.region) return false;
    if (opts.year && opts.year !== "全部" && String(m.year) !== opts.year) return false;
    if (opts.genre && opts.genre !== "全部" && !m.genres.includes(opts.genre)) return false;
    return true;
  });
}

export function sortMovies(list: Movie[], sort: string): Movie[] {
  const copy = [...list];
  if (sort === "popular") {
    return copy.sort((a, b) => b.views - a.views);
  }
  if (sort === "rating") {
    return copy.sort((a, b) => b.rating - a.rating);
  }
  return copy.sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  );
}

export function searchMovies(list: Movie[], keyword: string): Movie[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return list.filter(
    (m) =>
      m.title.toLowerCase().includes(kw) ||
      m.genres.some((g) => g.toLowerCase().includes(kw)) ||
      m.cast.some((c) => c.toLowerCase().includes(kw)) ||
      m.director.toLowerCase().includes(kw) ||
      m.tags.some((t) => t.toLowerCase().includes(kw))
  );
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return String(views);
}